import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const stopFile = async (payload: { process: string }) => {
  const { process } = payload
  axios.post(`${getAPIService}/paging/stop/${process}`)
  return
}
